import { useState, useEffect } from 'react';
import { ImageDetail } from '../components/Property/Gallery/types';

const useValidImages = (images: ImageDetail[]): ImageDetail[] => {
    const [validImages, setValidImages] = useState<ImageDetail[]>([]);

    const isValidImageUrl = async (url: string | null): Promise<boolean> => {
        if (!url) return false;
        try {
            const response = await fetch(url, { method: 'HEAD' });
            return response.ok;
        } catch (error) {
            console.warn(`Errore nel controllare l'URL ${url}:`, error);
            return false;
        }
    };

    useEffect(() => {
        const filterValid = async () => {
            const results: boolean[] = await Promise.all(images.map(img => isValidImageUrl(img.urlBig)));
            const filteredImages = images.filter((_, index) => results[index]);
            setValidImages(filteredImages);
        };

        filterValid();
    }, [images]);

    return validImages;
};

export default useValidImages;